export enum CommsOptionEnum {
  Email = 'email',
  Text = 'text',
}

export enum CommsPreferenceEnum {
  AccountTransactions = 'accountTransactions',
  ChildUpdates = 'childUpdates',
  YourImpact = 'yourImpact',
  Communications = 'communications',
  HelpUsImprove = 'helpUsImprove',
  PrayerNetwork = 'prayerNetwork',
  ExplorerMagazine = 'explorerMagazine',
  VolunteeringVisits = 'volunteeringVisits',
}
